export enum StudyPlanStatus {
    ACTIVE = 'ACTIVE',
    PAUSED = 'PAUSED',
    CANCELLED = 'CANCELLED',
    COMPLETED = 'COMPLETED',
}

export const STUDY_PLAN_STATUS_CONFIG = {
    [StudyPlanStatus.ACTIVE]: {
        label: 'Đang học',
        cssClass: 'text-sm !bg-green-100 !text-green-700'
    },
    [StudyPlanStatus.PAUSED]: {
        label: 'Tạm dừng',
        cssClass: 'text-sm !bg-yellow-100 !text-yellow-700'
    },
    [StudyPlanStatus.CANCELLED]: {
        label: 'Đã hủy',
        cssClass: 'text-sm !bg-gray-100 !text-gray-700'
    },
    [StudyPlanStatus.COMPLETED]: {
        label: 'Hoàn thành',
        cssClass: 'text-sm !bg-blue-100 !text-blue-700'
    }
};

export const STUDY_PLAN_STATUS_OPTIONS = Object.entries(STUDY_PLAN_STATUS_CONFIG).map(([key, value]) => ({
    label: value.label,
    value: key,
    cssClass: value.cssClass
}));

export enum Skill {
    LIS = 'LIS',
    READ = 'READ',
    SPK = 'SPK',
    WRI = 'WRI',
    VOC = 'VOC',
    GRA = 'GRA',
    PRON = 'PRON',
}

export const SKILL_CONFIG = {
    [Skill.LIS]: {
        label: 'Lis',
        cssClass: 'text-sm !bg-purple-100 !text-purple-700'
    },
    [Skill.READ]: {
        label: 'Read',
        cssClass: 'text-sm !bg-blue-100 !text-blue-700'
    },
    [Skill.SPK]: {
        label: 'Spk',
        cssClass: 'text-sm !bg-orange-100 !text-orange-700'
    },
    [Skill.WRI]: {
        label: 'Wri',
        cssClass: 'text-sm !bg-red-100 !text-red-700'
    },
    [Skill.VOC]: {
        label: 'Voc',
        cssClass: 'text-sm !bg-green-100 !text-green-700'
    },
    [Skill.GRA]: {
        label: 'Gra',
        cssClass: 'text-sm !bg-yellow-100 !text-yellow-700'
    },
    [Skill.PRON]: {
        label: 'Pron',
        cssClass: 'text-sm !bg-gray-100 !text-gray-700'
    }
};

export const SKILL_OPTIONS = Object.entries(SKILL_CONFIG).map(([key, value]) => ({
    label: value.label,
    value: key,
    cssClass: value.cssClass
}));

